<header>
  <div id="logo-container">
    <a id="logo" [routerLink]="['/employees', 'dashboard']">
      <img src="assets/img/logo/logo-bisual-black.png" alt="bisual" />
      @if (me.role.slug === 'worker') {
        <span id="logo-subtitle">Employees</span>
      }
      @if (me.role.slug === 'client') {
        <span id="logo-subtitle">Clientes</span>
      }
      @if (me.role.slug === 'partner') {
        <span id="logo-subtitle">Colaboradores</span>
      }
    </a>
  </div>
  <div id="header-menu-container">
    <button mat-icon-button (click)="showHeaderMenu = !showHeaderMenu" id="toggle-menu-header">
      @if (!showHeaderMenu) {
        <mat-icon>expand_more</mat-icon>
      }
      @if (showHeaderMenu) {
        <mat-icon>expand_less</mat-icon>
      }
    </button>

    <div id="header-menu-content" [ngClass]="{ show: showHeaderMenu }">
      <app-navigation-history></app-navigation-history>

      @if (me.role.slug === 'worker') {
        <div class="clock-actions-group">
          <span [matTooltip]="scheduleButtonTooltip()" class="clock-button-wrapper">
            <button
              mat-stroked-button
              [ngClass]="{ warn: clock_schedule_status, success: !clock_schedule_status, 'is-absent': scheduleButtonDisabled() }"
              (click)="clickClock()"
              id="click-button"
              [disabled]="!canClickClock()"
            >
              {{ clock_schedule_status ? 'Salida' : 'Entrada' }}
              <mat-icon>{{ clock_schedule_status ? 'logout' : 'login' }}</mat-icon>
            </button>
          </span>

          <button
            mat-stroked-button
            id="free-time-button"
            [matTooltip]="'Gestionar tiempo de descanso.'"
            (click)="clickClockRest()"
            [disabled]="(!rest_status_last_in && !clock_rest_available) || !canClockIn() || isClockActionInProgress()"
            [ngClass]="{ 'is-absent': !canClockIn() }"
          >
            <div style="line-height: 1">
              <mat-icon id="timer">timer</mat-icon>
              @if (!rest_status_last_in) {
                <mat-icon id="play">play_circle</mat-icon>
              }
              @if (rest_status_last_in) {
                <mat-icon id="pause">pause</mat-icon>
              }
              <mat-progress-spinner [color]="colorRestSpinner" strokeWidth="2" mode="determinate" diameter="30" [value]="valueRestTime()">
              </mat-progress-spinner>
            </div>
          </button>
        </div>
      }

      @if ((employee.currentGuardStatus | async)?.active) {
        <button mat-stroked-button id="guardian-button">
          <div class="icon-wrapper">
            <mat-spinner color="warn" [strokeWidth]="2" [diameter]="33"></mat-spinner>
            <mat-icon>security</mat-icon>
          </div>
          <p>
            Guardia activada
            <span>Productos: {{ (employee.currentGuardStatus | async)?.company_product_names }}</span>
          </p>
        </button>
      }

      @if ((employee.meetingModeEnabled | async) === false && setSummary && me.role.slug === 'worker') {
        <button
          mat-stroked-button
          [matMenuTriggerFor]="hours_menu"
          id="hours-menu"
          [matTooltip]="
            setSummary.name + ': ' + (setSummary.done | secondsToStringTime) + ' / ' + (setSummary.expected | secondsToStringTime)
          "
        >
          <mat-icon class="hours-menu-chevron">expand_more</mat-icon>

          <div id="summary-circular-progress">
            <mat-progress-spinner
              [mode]="'determinate'"
              [value]="(setSummary.done / setSummary.expected) * 100"
              [diameter]="25"
              color="accent"
              [strokeWidth]="2.5"
            ></mat-progress-spinner>

            @if (setSummary.logoUrl !== null) {
              <img [src]="setSummary.logoUrl" [alt]="setSummary.name" />
            } @else {
              <mat-icon>schedule</mat-icon>
            }
          </div>

          <p class="hours-menu-label">
            <b>{{ setSummary.name }}</b
            >: {{ setSummary.done | secondsToStringTime }} / {{ setSummary.expected | secondsToStringTime }}
          </p>
        </button>

        <mat-menu #hours_menu="matMenu" xPosition="before">
          @for (element of workingTimeSummaryList; track $index) {
            <button mat-menu-item (click)="setWorkingTimeSummary($index)">
              @if (element.companyProductId !== null) {
                <b mat-mdc-button matTooltip="Ir al producto">
                  <a
                    [routerLink]="['/employees', 'development', 'company-products', element.companyProductId]"
                    style="color: inherit; text-decoration: unset"
                    >{{ element.name }}</a
                  >
                </b>
              } @else {
                <b> {{ element.name }} </b>
              }
              : {{ element.done | secondsToStringTime }} / {{ element.expected | secondsToStringTime }}
            </button>
          }

          <mat-divider></mat-divider>

          <button mat-menu-item (click)="fetchWorkingTimeSummary()">
            <mat-icon>refresh</mat-icon>
            Actualizar
          </button>
        </mat-menu>
      }

      <app-recording-status-bar></app-recording-status-bar>

      @if ((employee.meetingModeEnabled | async) === false && me.role.slug !== 'partner') {
        @if (show_live_task_indicator) {
          <div id="next-task-div">
            <img id="gif-task" src="assets/img/icons/live_task_icon.gif" alt="Live task indicator" />
            <div id="task-titles">
              @if (currentTaskTitle !== null) {
                <div id="current-task-row">
                  <p id="current-task" [matTooltip]="currentTaskTitle">{{ currentTaskTitle }}</p>
                  @if (currentTaskCallLink) {
                    <a
                      id="join-meeting-link"
                      [href]="currentTaskCallLink"
                      target="_blank"
                      rel="noopener noreferrer"
                      matTooltip="Abrir enlace de la reunión"
                    >
                      <mat-icon>videocam</mat-icon>
                      Unirme
                    </a>
                  }
                </div>
              }
              @if (nextTaskTitle !== null && nextTaskTitle !== '') {
                <p id="next-task" [matTooltip]="nextTaskTitle">Next: {{ nextTaskTitle }} ({{ nextStartDate | date: 'shortTime' }})</p>
              }
            </div>
          </div>
        }
      }

      <button mat-stroked-button [matMenuTriggerFor]="quick_links_menu" id="quick-links-menu" [matTooltip]="'Enlaces rápidos'">
        <mat-icon style="margin: 0">more_vert</mat-icon>
      </button>
      <mat-menu #quick_links_menu="matMenu" xPosition="before">
        @if ((employee.meetingModeEnabled | async) === false) {
          @if (me.role.slug === 'worker') {
            <button class="quick-action" mat-menu-item (click)="addWorkingTime()">
              <mat-icon>add</mat-icon>
              <div>
                <span>Registrar tiempo trabajado</span>
                <p class="subtitle">+</p>
              </div>
            </button>
          }
          <button class="quick-action" mat-menu-item (click)="openGeneralSearch()">
            <mat-icon>search</mat-icon>
            <div>
              <span>Búsqueda avanzada</span>
              <p class="subtitle">Ctrl · k / ¡</p>
            </div>
          </button>
          @if (me.role.slug === 'worker') {
            <button class="quick-action" mat-menu-item (click)="openBisualBudgetRequest()">
              <mat-icon>request_quote</mat-icon>
              <div>
                <span>Solicitud de partida presupuestaria</span>
              </div>
            </button>
            <button class="quick-action" mat-menu-item (click)="openConfigureBisualMcpDialog()">
              <mat-icon>extension</mat-icon>
              <div>
                <span>Configurar MCP de Bisual</span>
                <p class="subtitle">Cursor · VS Code · Claude · ChatGPT</p>
              </div>
            </button>
          }
          @if (permissions.isAdmin()) {
            <button class="quick-action" mat-menu-item (click)="requestPostgresBisualDatabaseGrant()">
              <mat-icon>storage</mat-icon>
              <div>
                <span>Acceso escritura BBDD (1h)</span>
              </div>
            </button>
          }
        } @else {
          <button class="quick-action" mat-menu-item (click)="cleanShareScreen()">
            <mat-icon>domain_verification_off</mat-icon>
            Desactivar modo reunión
          </button>
        }

        @if (platform.isElectronApp()) {
          @if (platform.newVersionAvailable()) {
            <button class="quick-action" mat-menu-item (click)="openUpdateDialog()" style="color: var(--blue_color)">
              <mat-icon>system_update</mat-icon>
              <div>
                <span>Actualización disponible</span>
                <p class="subtitle">{{ platform.newVersionAvailable() }}</p>
              </div>
            </button>
          }
        }

        @if (platform.isElectronApp()) {
          <button class="quick-action" mat-menu-item (click)="reload()">
            <mat-icon>refresh</mat-icon>
            Actualizar página (F5)
          </button>

          <button class="quick-action" mat-menu-item (click)="copyLink()">
            <mat-icon>link</mat-icon>
            Copiar link
          </button>

          <button class="quick-action" mat-menu-item (click)="openNewWindow()">
            <mat-icon>open_in_new</mat-icon>
            Abrir nueva ventana
          </button>
        }
      </mat-menu>

      <button id="account-button" mat-stroked-button [matMenuTriggerFor]="account_menu" class="account-button">
        <app-user-profile-picture class="account-button-avatar" [user]="me" [css_class]="'account-button-avatar'" alt="" />
        <span id="me-container">
          <span class="me-name-row">
            @if (employee.hasPendingSlackChatConnections()) {
              <span class="account-pending-dot" aria-hidden="true"></span>
            }
            <span class="me-name">{{ me.name + ' ' + me.surnames }}</span>
          </span>
          <span class="department">
            {{ role_string ?? '' }}
          </span>
        </span>
        <mat-icon iconPositionEnd>expand_more</mat-icon>
      </button>

      <mat-menu #account_menu="matMenu" xPosition="before">
        <a mat-menu-item [routerLink]="['employees/my-profile']" class="account-menu-profile-item">
          <mat-icon>account_circle</mat-icon>
          <span>Mi perfil</span>
          @if (employee.hasPendingSlackChatConnections()) {
            <span class="account-pending-dot account-pending-dot--menu" aria-hidden="true"></span>
          }
        </a>
        @if (parentUser !== null) {
          <button mat-menu-item (click)="desimpersonar()">
            <mat-icon>keyboard_return</mat-icon>
            Desimpersonar
          </button>
        }
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          Cerrar sesión
        </button>
      </mat-menu>
    </div>
  </div>
</header>
